<template>
  <div id="star" class="section nobg clearfix">
    <div class="divider divider-short divider-center">
      <i class="icon-circle"></i>
    </div>

    <div
      id="section-pricing"
      class="heading-block title-center nobottomborder page-section"
    >
      <h2>
        {{ $t('forhairstar') }}
        <!-- 포헤어 스타 -->
      </h2>
      <span>
      {{ $t('forhairentertainer') }}
        <!-- 수많은 연예인도 믿고 수술받는 포헤어 -->
      </span>
      <div class="col-lg-8 col-md-10 offset-lg-2 offset-md-1 topmargin ">
        <iframe
          width="560"
          height="315"
          :src=getYoutubeLink()
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Star",
  methods: {
    isVnLocale(){
      return this.$i18n.locale === 'vn';
    },
    getDetailYoutubePath(){
      return this.isZhLocale() ? "3FeWbARPEhM" : "xulZXVV-6_U";
    },
    getYoutubeLink(){
      let defaultUrl = "//www.youtube.com/embed/xulZXVV-6_U";
      let vnUrl = "https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fvietnam.FORHAIRclinic%2Fvideos%2F271219357536737%2F&show_text=0&width=560";

      return this.isVnLocale() ? vnUrl : defaultUrl;

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
